'use client'

import { memo } from 'react'

import Button from 'shared/ui/Button'
import { addTestId } from 'shared/utils/tests'

import { Cart } from '../../../types'
import { UseRebateCodes } from '../hooks/useDiscountCodes'

import CartBenefitCodesDrawer from './CartBenefitCodesDrawer'

interface CartBenefitCodesFormProps {
  isVisible?: boolean
  isOpen?: boolean
  cart: Cart | null
  rebateCodes: UseRebateCodes
  isMobile?: boolean
  isLoading?: boolean
}

const CartBenefitCodesForm = ({
  isVisible = true,
  rebateCodes,
  cart,
  isMobile,
  isLoading
}: CartBenefitCodesFormProps) => {
  if (!isVisible) return null

  const {
    activeCodes,
    handleRemoveCode,
    handleAddNewCode,
    handleClose,
    open,
    promoCode,
    setPromoCode,
    resetTrigger,
    hasCode,
    providedRebateCodes
  } = rebateCodes

  return (
    <div>
      <Button
        onClick={rebateCodes.handleOpen}
        variant='primaryOutline'
        size='medium'
        fullWidth
        {...addTestId(
          isMobile
            ? 'cart-summary-rebate-codes-button-mobile'
            : 'cart-summary-rebate-codes-button-desktop'
        )}
      >
        {rebateCodes.rebateCodesLabel}
      </Button>

      <CartBenefitCodesDrawer
        open={open}
        onClose={handleClose}
        promoCode={promoCode}
        setPromoCode={setPromoCode}
        resetTrigger={resetTrigger}
        hasCode={hasCode}
        handleAddNewCode={handleAddNewCode}
        activeCodes={activeCodes}
        handleRemoveCode={handleRemoveCode}
        providedRebateCodes={providedRebateCodes}
        cart={cart}
        isLoading={isLoading}
      />
    </div>
  )
}

export default memo(CartBenefitCodesForm)
